import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { TFunction } from "i18next";
import C76TwoColumnsTable, { C76TwoColumnsTableRow } from "../c76_two_columns_table/c76_two_columns_table";
import MainParagraph from "../../common_components/main_paragraph/main_paragraph";
import "./c77_professorship.scss";
import { ProfessorData } from "../c69_faculty/professor_component";

interface ProfessorshipData {
    title: string;
    course_code: string;
    sector: string;
    courseyear: number;
    semester: string;
    channel: string;
    credits: number;
    total_hours: number;
    teaching_hours: number;
    teaching_language?: string;
    course_content?: string;
    reference_books?: string;
    course_formative_objectives?: string;
    prerequisites?: string;
    teaching_method?: string;
    assessment_method?: string;
    criteria_deciding_subject_final_paper?: string;
    weeks_contents: any;
    professors?: ProfessorData[];
    sostenibilita_content?: string;
}

class C77Professorship extends TemplateComponent<ProfessorshipData> {

    constructor(props: any) {
        super(props);

        this.requireInternationalization = true;
    }

    internationalComponentRender(data: any, t: TFunction): React.ReactElement<any> {

        // 1. a first table with professors, course code, sector, courseyear, semester, channel, credits, total hours, teaching hours, teaching language
        // 2. a list of texts with titles for course_content, reference_books, course_formative_objectives, prerequisites, teaching_method, assessment_method and criteria_deciding_subject_final_paper
        // 3. finally a table for weeks_contents
        // ...the client wants to put everything inside a table...

        // just to be clear, I haven't decided to put EVERYTHING inside a table, it is a decision made by the client

        const textualItems = ["course_formative_objectives", "intended_learning_outcomes", "prerequisites", "course_content", "reference_books",
            "teaching_method", "assessment_method", "criteria_deciding_subject_final_paper"];

        const generalTableData: C76TwoColumnsTableRow[] = [
            {
                header: t("C77 header professors"),
                text: data.professors ? data.professors.map((prof: { name: any; surname: any; }) => `${prof.name} ${prof.surname}`).join(" / ") : ""
            },
            ...["course_code", "sector", "courseyear", "semester", "channel", "credits", "total_hours", "teaching_hours"]
                .filter(item => (data as any)[item])
                .map(item => ({
                    header: t("C77 header " + item.split("_").join(" ")),
                    text: (data as any)[item] as string
                })),
            {
                header: t("C77 header teaching language"),
                text: data.teaching_language === 'en' ? t("C77 value english") : t("C77 value italian")
            },
            ...textualItems.filter(item => (data as any)[item]).map(item => ({
                header: t("C77 header " + item.split("_").join(" ")),
                text: (data as any)[item] as string
            })),

        ];

        if (data.weeks_contents) {
            generalTableData.push(...[
                {
                    header: t("C77 header program"),
                    text: "",
                    merge: true
                },
                ...[...Object.keys(data.weeks_contents)].map((week: string) => ({
                    header: `${week} / ${t("C77 header week")}`,
                    text: data.weeks_contents[week]
                })),
                ...["sostenibilita_content"]
                .filter(item => (data as any)[item])
                .map(item => ({
                    header: t("C77 header " + item.split("_").join(" ")),
                    text: (data as any)[item] as string
                })),
            ])
        }

        let componentProps = {
            layoutColumns: this.props.layoutColumns,
            language: this.props.language
        };

        return (
            <div className="c77-professorship auto-margins">
                <MainParagraph title={t("C77 header general table")} />
                <C76TwoColumnsTable data={generalTableData} {...componentProps} />
                {/*textualItems.filter(item => (data as any)[item]).map(item => (
                    <MainParagraph title={t("C77 header " + item.split("_").join(" "))}
                                   text={(data as any)[item]} />
                ))*/}
                {/*data.weeks_contents &&
                    <div className="weekly-contents">
                        <MainParagraph title={t("C77 header program")} />
                        <C0CustomBlock  {...componentProps} data={{
                            html:
                                <>{
                                    [...Object.keys(data.weeks_contents)].map((week: string) => (
                                        <div key={`week-content-${week}`}>
                                            <h5>{week}</h5>
                                            <p {...insertHtml(data.weeks_contents[week])} />
                                        </div>
                                    ))
                                }</>
                        }} />
                    </div>
                */}
            </div>
        )
    }
}

export default C77Professorship;